import React from 'react';
import './SmartBadge.css';

/**
 * props:
 * - id
 * - text
 * - onClick
 * - children
 * - variant: 'info' (default) | 'danger'
 */
function SmartBadge(props) {
    const v = props.variant || 'info';

    // palette = { bg, fg, accent }: cor vívida inline, independente do tema Bootstrap
    // (o `primary` deste app é navy escuro — não serve pra "azul"). Sobrepõe a classe.
    const p = props.palette;
    if (p) {
        return (
            <div className='input-group me-2 d-flex flex-row flex-nowrap'>
                <span id='spanNoWrap' className='alert py-1 mb-0'
                    style={{ backgroundColor: p.bg, color: p.fg, borderColor: p.accent }}>
                    {props.children}{props.text}
                </span>
                <button type='button' id={props.id} className='btn btn-xs alert mb-0'
                    style={{ backgroundColor: p.accent, color: '#fff', borderColor: p.accent }}
                    title='Click to Remove' onClick={props.onClick}>
                    X
                </button>
            </div>
        );
    }

    return (
        <div className='input-group me-2 d-flex flex-row flex-nowrap'>
            <span id='spanNoWrap' className={`alert alert-${v} py-1`}>
                {props.children}{props.text}
            </span>
            <button type='button' id={props.id} className={`btn btn-${v} btn-xs alert`} title='Click to Remove' onClick={props.onClick}>
                X
            </button>
        </div>
    )
}

export default SmartBadge;